import { BASE_URL } from '../../config';

/**
 * Periodically pulls account info and hands it to a callback.
 * Returns a stop() cleanup.
 */
export function startAccountSync({
    wallet_address,
    jwt,
    onUpdate,
    onError,
    intervalMs = 10_000,
    apiUrl,
}) {
    const endpoint = apiUrl || `${BASE_URL}/get_account_info`;

    if (!wallet_address || !jwt) {
        console.warn('[AccountSync] Missing wallet_address or jwt.');
        return () => { };
    }

    let stopped = false;
    let timer = null;

    const syncOnce = async () => {
        try {
            const res = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ address: wallet_address, jwt }),
            });
            if (!res.ok) throw new Error(`API error: ${res.status}`);
            const data = await res.json();
            if (!stopped && onUpdate) onUpdate(data);
        } catch (err) {
            console.error('[AccountSync] Error', err);
            if (!stopped && onError) onError(err);
        }
    };

    // initial fetch now
    syncOnce();
    // and every interval
    timer = setInterval(syncOnce, intervalMs);

    return () => {
        stopped = true;
        if (timer) clearInterval(timer);
    };
}
